<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni <$email>

  This file TileListItem.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  TileListItem.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: TileListItem 
 Created by keni.
 with: IntelliJ IDEA
 Date: 29/03/2018
 Time: 13:09
------------------------------------------------------------------------------->
<template>
    <div class=" mx-2 my-4" :class="base_class">
        <!--{{debug(item_attributes)}}-->
        <div v-for="item_attribute in item_attributes">
            <!--{{debug(item_attribute)}}-->

            <div v-if="item_attribute.slug === 'featured'" class="ribbon-xl-wrapper">
                <div class="ribbon-xl primary-ribbon">Featured</div>
            </div>
            <div v-if="item_attribute.slug === 'recommended'" class="ribbon-xls-wrapper">
                <div class="ribbon-xls success-ribbon">Recommended</div>
            </div>
        </div>

        <!--add the image-->
        <a :href="routes.image"
        >
            <figure class=""
                    :class="base_class + '--image-wrapper'">
                <img class="carousel-3d-film-roll--image"
                     :class="base_class + '--image'"
                     :src="image_data.src"
                >
            </figure>

        </a>

        <!--the main caption-->
        <div class="pb-1 p-3 px-md-6 pt-md-2 pb-md-4"
             :class="base_class + '--contents'">
            <div class=""
                 :class="base_class + '--contents-main-icon'">
                <i :class="icon"></i>
            </div>
            <a class="d-block white-text text-lowercase mb-1 fs-14"
               :class="base_class + '--contents-jumbo'"
               :href="routes.item"
            >
                <bold-word :first_word_bold="true" :word="item_date"></bold-word>
            </a>
            <a class="d-block white-text text-uppercase fs-3 h5 mb-3"
               :class="base_class + '--contents-title-small'"
               :href="routes.category"
            >{{category_title}}</a>


            <a class=" h1 white-text text-uppercase fs-6"
               :class="base_class + '--contents-title'"
               :href="routes.item"
            >
                {{item_title}}
            </a>
        </div>
    </div>
</template>

<script>
	import {_} from 'underscore';

	Vue.component('bold-word', require('../typography/BoldWord'));
	export default {
		name: "tile-list-item",
		components: {},
		props: [

			'base_class',
			'item_date',// {!! Html::first_word_bold($event_date) !!}
			'item_attributes',
			'item_title',//@langData($event_data,'title')
			'category_title',//@langData($category_data,'title') Event
			'image_data',
			'icon', //$category_data->icon->icon
			'routes'

		],
		created() {
		},
		destroyed() {
		},
		mounted() {
// console.log('item_attributes',this.item_attributes);
		},
		data() {
			return {}
		},
		methods: {
			debug(args) {
				// console.log('args',args);
			}
		},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/tiles/TileListItem.vue